import { CurrencyPipe, DecimalPipe, PercentPipe } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AmpService } from '../amp-service/amp.service';
import { Filtros } from './../../../../shared/crud/Filtro/Filtros';
import { ListaBase } from './../../../../shared/crud/ListaBase';
import { ExportExcelService } from './../../../../shared/excel-service/export-excel.service';

@Component({
  selector: 'app-amp-lista',
  templateUrl: './amp-lista.component.html',
  styles: [`
.text-right {
text-align: right;
}
`],
  styleUrls: ['./amp-lista.component.css']
})
export class AmpListaComponent extends ListaBase implements OnInit {

  carregando = false;
  parametrosFiltro: any;
  filtors: any = {};
  InicialData; // Set the first Day of month
  FinalData; // set the last day of query
  cols: any[];
  _selectedColumns: any[];
  tipo: any;
  data: any;
  tempDados: any;
  nome_dealer: string;
  quantidadeDealers: number = 0
  percentual = 0
  estoque = 0
  manter = 0
  comprar = 0

  dadosTranslate = {
    "Nome": "estoque.amp.nome",
    "Estoque": "estoque.amp.estoque",
    "Manter": "estoque.amp.manter",
    "Comprar": "estoque.amp.comprar",
    "Brasil": "estoque.amp.brasil"
  }

  constructor(service: AmpService,
    toast: ToastrService,
    router: Router,
    private exportExcel: ExportExcelService,
    private translate: TranslateService,
    private cdRef: ChangeDetectorRef,
    private currency: CurrencyPipe,
    private number: DecimalPipe,
    private percent: PercentPipe) {
    super(service, toast, router);
    this.filtros = {};
    this.nomeModulo = 'amp';
    this.exibirBotaoDetalhesIcon = true;
  }

  @Input() set carregar(valores: any[]) {
    if (valores.length > 0) {
      this.limparFiltros();
      valores.forEach(item => {
        new FiltroDealer(new FiltroEspecifico(null))
          .gerar(item, this.filtros);
      });
    } else {
      this.limparFiltros();
    }
    //this.buscar();
  }

  ngOnInit(): void {
    this.setaValorData(null, null);
    this.buscar();
    this.cols = [
      { field: 'detalhe', header: '' },
      { field: 'codigo_dealer', header: 'Dealers' },
      { field: 'nome_dealer', header: 'Nome' },
      { field: 'estoque', header: 'Estoque', type: this.number, arg1: '1.2-2' },
      { field: 'manter', header: 'Manter', type: this.number, arg1: '1.2-2' },
      { field: 'comprar', header: 'Comprar', type: this.number, arg1: '1.2-2' },
      { field: 'percentual', header: '%', type: this.percent, arg1: '1.0-0' },
    ];

    this._selectedColumns = this.cols;
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    //restore original order
    this._selectedColumns = this.cols.filter(col => val.includes(col));
  }

  setaValorData(data: any, tipo: any) {
    //set data
    if (data === undefined || data === null) {
      this.data = this.dataAtualFormatada();
    } else {
      this.data = data;
    }

    this.filtros = { data: this.data };
  }


  dataAtualFormatada() {
    var data = new Date(),
      dia = data.getDate().toString(),
      diaF = (dia.length == 1) ? '0' + dia : dia,
      mes = (data.getMonth() + 1).toString(), //+1 pois no getMonth Janeiro começa com zero.
      mesF = (mes.length == 1) ? '0' + mes : mes,
      anoF = data.getFullYear();
    return diaF + "/" + mesF + "/" + anoF;
  }

  carregarFiltrosParametros() {
    if (this.parametrosFiltro) {
      for (const item in this.parametrosFiltro) {
        if (this.parametrosFiltro.hasOwnProperty(item)) {

          this.filtros[item] = this.parametrosFiltro[item];
        }
      }
    }
  }

  buscar() {
    this.nome_dealer = 'Brasil';
    let objFiltro: Filtros = new Filtros();
    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {
        super.incluirItemFiltro(chave, objFiltro);
      }
    }
    this.carregando = true
    this.service.buscar(objFiltro).then(res => {
      this.tempDados = res.dados;

      this.calculandoTotal(res)
      this.orderByPercentual();

      this.carregando = false
    });
  }

  private orderByPercentual() {
    this.tempDados.sort((a, b) => {
      let percentual_a = a.percentual;
      let percentual_b = b.percentual;

      if (percentual_a > percentual_b) return -1;
      if (percentual_a < percentual_b) return 1;

      return 0;
    });
  }

  getColor(index: any): string {
    let maior: string = "#9cc09c";
    let menor: string = "#c09c9c";

    if (index.percentual >= this.percentual) {
      return maior;
    } else {
      return menor;
    }
  }

  protected getListagemComFiltros(): boolean {
    return this.filtros.data_inicial
      || this.filtros.data_final
  }

  limparFiltros(): any {
    this.filtros.dealers = '';
    this.filtros.data_inicial = null;
    this.filtros.data_final = null;
  }

  exportarExcel() {
    this.exportExcel.nomeModulo = this.nomeModulo;
    this.exportExcel.ExportTOExcel();
  }

  getTranslate(value) {
    return this.dadosTranslate[value];
  }

  ngAfterViewChecked() {
    if (this.translate.currentLang === 'gb') {
      this.translate.use('br');
      this.translate.use('gb');
    }
    this.getTranslate('');
    this.cdRef.detectChanges();
  }

  getById(index: number) {
    const dealerCode = this.tempDados[index].codigo_dealer
    this.router.navigateByUrl('estoque/amp-detalhado?dealer=' + dealerCode);
  }


  calculandoTotal(res) {
    this.quantidadeDealers = res.dados.length
    this.nome_dealer = "Brasil"
    this.comprar = res.totalComprar;
    this.estoque = res.totalEstoque;
    this.manter = res.totalManter;
    this.percentual = res.totalPercentual;
  }
}

abstract class GerarFiltro {
  proximoGerador: GerarFiltro;

  constructor(proximoGerador: GerarFiltro) {
    this.proximoGerador = proximoGerador;
  }
  public abstract gerar(item: any, filtros: any);

}

class FiltroDealer extends GerarFiltro {
  public gerar(item: any, filtros: any) {
    if (item.chave === 'dealers') {
      const itens: string[] = [];
      item.valor.forEach(element => {
        itens.push(element);
      });
      filtros.dealers = itens;
    } else {
      this.proximoGerador.gerar(item, filtros);
    }
  }
}

class FiltroEspecifico extends GerarFiltro {
  public gerar(item: any, filtros: any) {
    filtros[item.chave] = item.valor;
  }
}